import PageShell from "@/components/site/PageShell";
import PageHero from "@/components/site/PageHero";
import { usePageContent } from "@/i18n/pageContent";

export default function AboutUs() {
  const c = usePageContent("about");
  return (
    <PageShell>
      <PageHero
        eyebrow={c.eyebrow}
        title={<>{c.titleA} <span className="italic">{c.titleB}</span></>}
        subtitle={c.subtitle}
        image="/about-hero.jpg"
      />
      <section className="bg-white py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          <div className="lg:col-span-7 space-y-6 reveal">
            <span className="eyebrow">{c.sec1Eyebrow}</span>
            <h2 className="font-display text-3xl md:text-5xl text-[#1a365d] leading-[1.08] tracking-tight">
              {c.sec1Title1} <span className="italic">{c.sec1Title2}</span> {c.sec1Title3}
            </h2>
            <p className="text-[#475569] leading-[1.85] text-base md:text-[17px]">
              <strong className="text-[#1a365d]">{c.sec1Para1Strong}</strong> {c.sec1Para1}
            </p>
            <p className="text-[#475569] leading-[1.85] text-base md:text-[17px]">
              {c.sec1Para2Pre} <em>&quot;{c.sec1Para2Em}&quot;</em>{c.sec1Para2}
            </p>
          </div>
          <aside className="lg:col-span-5 reveal delay-1">
            <div className="bg-[#fafaf7] border-l-2 border-[#d4af37] p-8 md:p-10">
              <span className="eyebrow">{c.asideEyebrow}</span>
              <h3 className="font-display text-2xl md:text-3xl text-[#1a365d] mt-4 leading-tight">
                {c.asideTitle}
              </h3>
              <p className="text-[#475569] leading-[1.85] mt-5 text-[15px]">
                {c.asidePara1Pre} <em>{c.asidePara1Em}</em>{c.asidePara1}
              </p>
              <p className="text-[#475569] leading-[1.85] mt-4 text-[15px]">
                {c.asidePara2Pre} <strong>{c.asidePara2Strong}</strong> {c.asidePara2}
              </p>
            </div>
          </aside>
        </div>
      </section>
    </PageShell>
  );
}
